import { __module as A } from "../../../_virtual/isUUID.js";
import { a as F } from "./util/assertString.js";
Object.defineProperty(e = A.exports, "__esModule", {
  value: !0
}), e.default = function (A, F) {
  (0, t.default)(A);
  var e = l[[void 0, null].includes(F) ? "all" : F];
  return !!e && e.test(A);
}, t = F && F.__esModule ? F : {
  default: F
}, l = {
  1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
  2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
}, A.exports = e.default, A.exports.default = e.default;
var e,
  t,
  l,
  r = A.exports;
export { r as i };